function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10 0a10 10 0 100 20 10 10 0 000-20zm0 4.435a1.694 1.694 0 110 3.388 1.694 1.694 0 010-3.388zm2.258 10.242a.484.484 0 01-.484.484H8.226a.484.484 0 01-.484-.484v-.967a.484.484 0 01.484-.484h.484v-2.58h-.484a.484.484 0 01-.484-.485v-.968a.484.484 0 01.484-.484h2.58a.484.484 0 01.485.484v4.032h.484a.484.484 0 01.484.484l-.001.968z",
  fill: "params(fill) #00478C"
});
function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default SvgInfo;